import _styled from "styled-components";
import { graphql, useFragment, type FragmentType } from "~/gql/runtime";
import { Link } from "~/features/ui/link";
import { takeFirst } from "~/features/app/utils";
import { useSubNavLayout } from "~/features/sub-nav/context";
import { getSubNavThemeStyle } from "~/features/sub-nav/sub-nav-theme";
import { isLinkValid } from "~/features/ui/link/utils";
const hoverStyles = {
  light: {
    "@media (hover: hover)": {
      "&:hover": {
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgb(208 208 218 / var(--tw-bg-opacity))"
      }
    }
  },
  dark: {
    "@media (hover: hover)": {
      "&:hover": {
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgb(92 92 92 / var(--tw-bg-opacity))"
      }
    }
  }
} as const;
const fragment = graphql(`
  fragment SubNavLink on subNavLinks_link_BlockType {
    link: baseLink {
      ...Link
    }
  }
`);
export function SubNavLink(props: FragmentType<typeof fragment>) {
  const {
    link: _link,
    ...rest
  } = useFragment(fragment, props);
  const link = takeFirst(_link);
  const {
    subNavMode
  } = useSubNavLayout();
  const themeStyle = getSubNavThemeStyle(subNavMode);
  if (!isLinkValid(link)) {
    return null;
  }
  return <_StyledLink {...link} {...rest} $_css={[{
    "display": "flex",
    "height": "5.6rem",
    "width": "100%",
    "alignItems": "center",
    "paddingLeft": "2.4rem",
    "paddingRight": "2.4rem",
    "transitionProperty": "color, background-color, border-color, text-decoration-color, fill, stroke",
    "transitionDuration": "250ms",
    "@media (min-width: 1024px)": {
      "height": "7.2rem",
      "paddingLeft": "4rem",
      "paddingRight": "4rem"
    }
  }, themeStyle.background, themeStyle.border, themeStyle.text, hoverStyles[subNavMode]]} />;
}
var _StyledLink = /*#__PURE__*/_styled(Link).withConfig({
  displayName: "sub-nav-link___StyledLink",
  componentId: "sc-1lcwyq8-0"
})(["", ""], p => p.$_css);